import React from "react";

const PaymentCard = ({ name, length, amount }) => {
  return (
    <div className="col-span-1 bg-gray-200 rounded-xl px-2 py-3 flex justify-between items-center">
      <div className="w-12 h-12 bg-yellow-200 rounded-xl text-sm flex justify-center items-center">
        {length}
      </div>
      <div className="text-center">
        <p className="text-xs font-medium">{name}</p>
        <h3 className="text-lg mx-auto">
          {amount && `$ ${amount.toFixed(2)}`}
        </h3>
      </div>
    </div>
  );
};

export default PaymentCard;
